"use client"

import { useState } from "react"
import { auth, db } from "../Firebase/firebase-config"
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth"
import { ref, get } from "firebase/database"
import { useNavigate } from "react-router-dom"
import "./PartnerLogin.css"

export default function PartnerLogin() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const [resetOpen, setResetOpen] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [resetMsg, setResetMsg] = useState("")
  
  const navigate = useNavigate()
  

  // const handleLogin = async (e) => {
  //   e?.preventDefault()
  //   setError("")
  //   setResetMsg("")
  //   setLoading(true)
  //   try {
  //     const userCredential = await signInWithEmailAndPassword(auth, email, password)
  //     const partnerUid = userCredential.user.uid

  //     const profileRef = ref(db, "profileDashboard")
  //     const snapshot = await get(profileRef)

  //     let mainUserId = null
  //     snapshot.forEach((mainSnap) => {
  //       const partners = mainSnap.child("partners").val()
  //       if (partners && partners[partnerUid]) {
  //         mainUserId = mainSnap.key
  //       }
  //     })

  //     if (!mainUserId) {
  //       setError("No main user found for this partner.")
  //       await auth.signOut();
  //       setLoading(false)
  //       return
  //     }

  //     navigate("/partner-dashboard", { state: { mainUserId, isPartner: true } })
  //   } catch (err) {
  //     setError(err?.message || "Login failed")
  //   } finally {
  //     setLoading(false)
  //   }
  // }

  const handleLogin = async (e) => {
  e?.preventDefault()
  setError("")
  setResetMsg("")
  setLoading(true)

  try {
    // 1️⃣ Sign in first
    const userCredential = await signInWithEmailAndPassword(auth, email, password)
    const partnerUid = userCredential.user.uid

    // 2️⃣ Check if this UID exists under any main user's partners
    const profileRef = ref(db, "profileDashboard")
    const snapshot = await get(profileRef)

    let mainUserId = null

    snapshot.forEach((mainSnap) => {
      const partners = mainSnap.child("partners").val()
      if (partners && partners[partnerUid]) {
        mainUserId = mainSnap.key
      }
    })

    if (!mainUserId) {
      // UID not found in partners → not authorized
      setError("This account is not registered as a partner.")
      await auth.signOut()
      setLoading(false)
      return
    }

    // ✅ Authorized partner → navigate
    navigate("/partner-dashboard", { state: { mainUserId, isPartner: true } })

  } catch (err) {
    setError(err?.message || "Login failed")
  } finally {
    setLoading(false)
  }
}


  const handleReset = async (e) => {
    e?.preventDefault()
    setResetMsg("")
    setError("")
    try {
      if (!email) {
        setError("Please enter your email to reset the password.")
        return
      }
      await sendPasswordResetEmail(auth, email)
      setResetMsg("Password reset email sent. Please check your inbox.")
      setResetOpen(false)
    } catch (err) {
      setError(err?.message || "Failed to send reset email")
    }
  }

  return (
    <main style={{ minHeight: "100dvh", background: "#f5f7fa" }}>
      <section className="partner-login-container">
        <div className="partner-login-card" role="region" aria-labelledby="partner-login-title">
          <div className="partner-login-card-header">
            <h1 id="partner-login-title" className="partner-login-title">
              Welcome back
            </h1>
            <p className="login-subtle">Sign in to access your partner dashboard.</p>
          </div>
          <div className="partner-login-card-body">
            <form onSubmit={handleLogin} className="partner-login-form" noValidate>
              <div className="partner-form-field">
                <label htmlFor="email" className="partner-form-label">
                  Email
                </label>
                <input
                  id="email"
                  className="partner-form-input"
                  type="email"
                  inputMode="email"
                  autoComplete="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="partner-form-field">
                <label htmlFor="password" className="partner-form-label">
                  Password
                </label>
                <div className="password-wrapper">
                  <input
                    id="password"
                    className="partner-form-input"
                    type={showPassword ? "text" : "password"}
                    autoComplete="current-password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    tabIndex={-1} // prevents tab focus on button
                  >
                    {showPassword ? (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                        <line x1="1" y1="1" x2="23" y2="23" />
                      </svg>
                    ) : (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    )}
                  </button>
                </div>

              </div>
              {error && <p className="partner-error-msg">{error}</p>}
              {resetMsg && <p className="partner-success-msg">{resetMsg}</p>}
              <div className="partner-form-actions">
                <button type="submit" className="partner-btn-primary" disabled={loading}>
                  {loading ? "Signing in..." : "Sign In"}
                </button>
                <button type="button" className="partner-btn-link" onClick={() => setResetOpen(true)}>
                  Forgot password?
                </button>
              </div>
            </form>
          </div>
          <div className="partner-login-card-footer">
            <a href="/login" className="partner-inline-link">
              Back to login
            </a>
          </div>
        </div>
      </section>

      {resetOpen && (
        <div
          className="dialog-backdrop"
          role="dialog"
          aria-modal="true"
          aria-labelledby="reset-title"
          onClick={(e) => {
            if (e.target === e.currentTarget) setResetOpen(false)
          }}
        >
          <div className="dialog" onClick={(e) => e.stopPropagation()}>
            <div className="dialog-header">
              <h2 id="reset-title" className="partner-login-title">
                Reset password
              </h2>
              <p className="login-subtle">Enter your email to receive a reset link.</p>
            </div>
            <form onSubmit={handleReset}>
              <div className="dialog-body partner-login-form">
                <div className="partner-form-field">
                  <label htmlFor="reset-email" className="partner-form-label">
                    Email
                  </label>
                  <input
                    id="reset-email"
                    className="partner-form-input"
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="dialog-actions">
                <button type="button" className="btn-ghost" onClick={() => setResetOpen(false)}>
                  Cancel
                </button>
                <button type="submit" className="partner-btn-primary">
                  Send reset link
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </main>

  )
}